// start:ng42.barrel
export * from './pipes';
export * from './utils';
export * from './shared.module';
// end:ng42.barrel

